import Icon from '../components/Icon.vue'

Icon.register({
  handshake: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M434.7 64c8.5 0 16.7 3.4 22.6 9.4l54.6 54.6v193.5c-2.4-2.7-5-5.3-7.9-7.7l-145.6-118.2 26.1-23.9c6.5-6 7-16.1 1-22.6-5.9-6.5-16.1-6.9-22.6-1l-79.9 73.2c-0.1 0.1-0.3 0.1-0.4 0.2-16.7 14.9-43.4 11.2-56.1-2.7-14.2-15.5-14.5-40.4 2.1-56 0.1-0.1 0.2-0.3 0.3-0.4l98.3-90c5.9-5.4 13.6-8.4 21.6-8.4h85.9zM544 128.2h96v255.9h-64c-17.7 0-32-14.3-32-32v-223.9zM592 352.1c8.8 0 16-7.2 16-16 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 8.8 7.2 16 16 16zM0 384v-255.8h96v223.8c0 17.7-14.3 32-32 32h-64zM48 320.1c-8.8 0-16 7.1-16 16 0 8.8 7.2 16 16 16s16-7.2 16-16c0-8.8-7.2-16-16-16zM483.9 338.7c13.7 11.2 15.8 31.3 4.6 45.1l-9.5 11.7c-11.1 13.8-31.3 15.8-45 4.7l-5.4-4.4-31.4 38.6c-12.9 15.9-36.4 18.4-52.3 5.4l-17.9-15.5-0.2 0.2c-22.3 27.4-62.6 31.6-90 9.3l-90.5-81.9h-18.3v-223.9l54.7-54.6c6-6 14.1-9.4 22.6-9.4h83.8l-81.8 74.9c-29.2 26.8-31.3 72.3-4.4 101.7 26.5 28.9 72 31.5 101.7 4.4l30-27.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/handshake.js
// module id = 1441
// module chunks = 0